import FormMixin from '@com/mixins/form.mixin'
import { i18n } from '@js/i18n'
import { ErrorFactory } from '@js/errors/factory'

export default {
  mixins: [FormMixin],
  data: _ => ({
    form: {
      // form
    },
    resolvers: {
      resolve: () => {},
      reject: () => {}
    },
    isHide: false,
    isOpened: true,
    isResolved: false,
    i18n
  }),
  methods: {
    setResolvers (resolve, reject) {
      this.resolvers.resolve = resolve
      this.resolvers.reject = reject
    },
    resetResolvers () {
      this.isResolved = true
    },
    close () {
      this.resolvers.reject(ErrorFactory.getOTPCancelledError())
      this.resetResolvers()
      this.isOpened = false
      this.removeElement()
    },
    removeElement () {
      this.isHide = false
      this.isOpened = false
      if (this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/modals/flow-blocking-modal.mixin.js